import { createFileRoute } from "@tanstack/react-router";
import { StoreSettingsEditor } from "@/features/admin-settings/StoreSettingsEditor";
function Page() { const { session } = Route.useRouteContext(); return <StoreSettingsEditor key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/app-store-links")({ component: Page });
